/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterCredentials = {
  id: 'cluster-credentials.get',
  tag: 'Cluster',
  summary: 'Get cluster credentials',
  description: 'Retrieve the credentials of a cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/credentials`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            host: z.string().min(1),
            internalHost: z.string().min(1).optional(),
            replicaHost: z.string().min(1).optional(),
            port: z.number().min(0),
            internalPort: z.number().min(0),
            replicaPort: z.number().min(0).optional(),
            username: z.string().min(1),
            password: z.string().min(1),
            ingressHostname: z.string().min(1).optional(),
            masterIngressPort: z.string().min(0).optional(),
            replicaIngressPort: z.string().min(0).optional(),
            babelfish: z
              .strictObject({
                host: z.string(),
                port: z.number(),
              })
              .optional(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
